import React from 'react';

import {Link} from "react-router-dom";


import {germanLevels, ratings} from '../Constants';


function EmployeeEntry(props) {


    return (
        <>
            <tr className={Number(props.employee.Inactive) ? "inactive" : ""}>
                <td>{props.employee.LastName}</td>
                <td>{props.employee.FirstName}</td>
                <td>{props.employee.Partner ? props.employee.Partner : "-"}</td>
                <td>{props.employee.Nationality ? props.employee.Nationality : "-"}</td>
                <td>{props.employee.ActualGermanLevel >= 0 ? germanLevels[props.employee.ActualGermanLevel].label : "-"}</td>
                <td>{props.employee.Rating >= 0? ratings[props.employee.Rating].label : '-'}</td>
                <td>{props.employee.Recommendation > 0 ? "ja " : "nein"}</td>
                <td>{Number(props.employee.Inactive) ? "inaktiv" : "aktiv"}</td>
                <td>
                    <Link to={"/employee/" + props.employee.EmployeeID}>Details</Link>
                </td>
            </tr>
        </>
    );
}

export default EmployeeEntry;